import { track } from "shared/boot/analytics";
import { $streemApiV1 } from "shared/boot/api";
import { getSource } from "shared/helpers/media";
import OrganisationsService from "shared/services/api/OrganisationsService";
import { useUserStore } from "shared/stores/user";
import { type Mention } from "shared/types/mentions";

const handleErrors = true;

export default {
  createActivity(mention: Mention) {
    const source = getSource(mention.type);
    track("Created Activity", { feature: source.viewFeatureFlag });

    return $streemApiV1.post("activities", {
      handleErrors,
      params: {
        feature: source.viewFeatureFlag,
        target_id: mention.id,
        target_type: source.relatedCamelCaseField,
      },
    });
  },

  getActivitiesCount(mention: Mention): Promise<number> {
    const source = getSource(mention.type);

    return OrganisationsService.activities(useUserStore().organisation.id, {
      handleErrors,
      params: {
        limit: 0,
        target_id: mention.id,
        target_type: source.relatedCamelCaseField,
      },
    }).then((response) => parseInt(response.headers["x-total-count"], 10));
  },
};
